import { render, staticRenderFns } from "./NoticiasGuru.vue?vue&type=template&id=76d27b4f&scoped=true"
import script from "./NoticiasGuru.vue?vue&type=script&lang=js"
export * from "./NoticiasGuru.vue?vue&type=script&lang=js"
import style0 from "./NoticiasGuru.vue?vue&type=style&index=0&id=76d27b4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d27b4f",
  null
  
)

export default component.exports